import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import GetApp from "../components/GetApp";
import { Helmet } from "react-helmet";

const Terms = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Privacy Policy - Boque</title>
        <link rel="canonical" href="https://boque.me/privacy" />
        <meta name="description" content="App and Web privacy policy" />
      </Helmet>
      <div
        className="header-small"
        style={{ backgroundImage: "url(/images/tile_background.png)" }}
      >
        <Container>
          <Row>
            <Col>
              <h1>Privacy Policy</h1>
              <p className="mt-3 fs-4">Last updated: 29th January 2025</p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="mt-3">
          <Col sm={12}>
            <p>
              Boque ("us", "we", or "our") operates the Boque mobile
              applications (Client and Service Provider versions), and marketing
              website (collectively referred to as the "Service").
            </p>

            <h2>Information Collection and Use</h2>
            <p>
              <strong>For Clients:</strong>
            </p>
            <ul>
              <li>Personal identification (name, email, phone number)</li>
              <li>
                Payment information (credit card details via secure processor)
              </li>
              <li>Service location addresses</li>
              <li>Service preferences and history</li>
              <li>Device location (for service matching)</li>
            </ul>

            <p>
              <strong>For Service Providers:</strong>
            </p>
            <ul>
              <li>Professional credentials (licenses, certifications)</li>
              <li>Bank account details (for payments)</li>
              <li>Service portfolio and availability</li>
              <li>GPS location (for job assignments)</li>
              <li>Ratings and client feedback</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <ul>
              <li>Facilitate service bookings and transactions</li>
              <li>Verify professional credentials of service providers</li>
              <li>Process payments and earnings</li>
              <li>Improve service matching through location data</li>
              <li>Send important service notifications</li>
              <li>Provide customer support</li>
            </ul>

            <h2>Data Sharing</h2>
            <p>
              We share minimal necessary information between clients and service
              providers to facilitate bookings, including:
            </p>
            <ul>
              <li>
                Client contact information with confirmed service providers
              </li>
              <li>Service provider profiles with potential clients</li>
              <li>Transaction details with payment processors</li>
            </ul>

            <h2>Security Measures</h2>
            <p>We implement industry-standard security measures including:</p>
            <ul>
              <li>SSL encryption for all data transfers</li>
              <li>Tokenized payment processing</li>
              <li>Regular security audits</li>
              <li>Two-factor authentication options</li>
            </ul>

            <h2>Location Data</h2>
            <p>We collect precise location data to:</p>
            <ul>
              <li>Match clients with nearby service providers</li>
              <li>Verify service completion locations</li>
              <li>Optimize service provider routes</li>
            </ul>

            <h2>Third-Party Services</h2>
            <p>We use third-party services that collect anonymized data for:</p>
            <ul>
              <li>Payment processing (Stripe, PayPal)</li>
              <li>Analytics (Google Analytics, Firebase)</li>
              <li>Crash reporting (Sentry)</li>
            </ul>

            <h2>Your Rights</h2>
            <ul>
              <li>Request access to your personal data</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your account data</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2>Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under 18. We do not
              knowingly collect personal information from minors without
              parental consent.
            </p>

            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy periodically. Significant changes
              will be notified through:
            </p>
            <ul>
              <li>In-app notifications</li>
              <li>Email alerts to registered users</li>
              <li>Website banner notices</li>
            </ul>
            <p>This policy is effective as of 29th January 2025</p>

            <h2>Contact Us</h2>
            <p>
              For privacy-related inquiries, contact our Data Protection Officer
              at:
              <br />
              <a href="mailto:info@boque.me">info@boque.me</a>
            </p>
          </Col>
        </Row>
      </Container>
      <GetApp />
    </>
  );
};

export default Terms;
